module.exports = __webpack_public_path__ + "static/media/play-background-5.0806b0c6.jpg";